import React from "react";
import styles from "./isGeometricallyValidCell.module.scss";
import {Icon} from "@fluentui/react";


interface IsGeometricallyValidCellProps {
  isGeometricallyValid?: boolean;
  geometricalValidationErrorMessages?: string[];
}

const IsGeometricallyValidCell: React.FunctionComponent<
  IsGeometricallyValidCellProps
> = ({isGeometricallyValid, geometricalValidationErrorMessages}) => {
  if (isGeometricallyValid === null) {
    return (
      <Icon
        iconName="Error"
        className={styles.validationIconNotValidated}
        title="Validation is not performed"
      />
    );
  } else if (isGeometricallyValid) {
    return (
      <Icon
        iconName="Completed"
        className={styles.validationIconSuccessful}
        title="Validation is successful"
      />
    );
  } else {
    let errors = "";
    if (
      geometricalValidationErrorMessages !== null &&
      geometricalValidationErrorMessages !== undefined
    ) {
      errors = geometricalValidationErrorMessages.join("\n");
      return (
        <Icon
          iconName="ErrorBadge"
          className={styles.validationIconFailedWithMessage}
          title={errors}
        />
      );
    }
    return (
      <Icon
        iconName="ErrorBadge"
        className={styles.validationIconFailed}
        title="No detailed message is provided"
      />
    );
  }
};

export default IsGeometricallyValidCell;
